// 表单项保存文件
const state={
  landForm:null, //土地资源
  landTool:null,//地图工具
  plateValue:null,//投资决策 板块价值
  landValue:null,//投资决策 土地资源
  RegulatoryPlan:null,//矢量控规
  PoiResource:null,//配套资源
  LandAnalysisData:null,
}
const mutations = {
  SET_LANDFORM(state, landForm){
    state.landForm = landForm;
  },
  SET_LANDTOOL(state, landTool){
    state.landTool = landTool;
  },
  SET_PLATEVALUE(state, plateValue){
    state.plateValue = plateValue;
  },
  SET_LANDVALUE(state, landValue){
    state.landValue = landValue;
  },
  SET_REGULATORYPLAN(state, RegulatoryPlan){
    state.RegulatoryPlan = RegulatoryPlan;
  },
  SET_POIRESOURCE(state, PoiResource){
    state.PoiResource = PoiResource;
  },
  SET_LANDANALYSISDATA(state, LandAnalysis){
    state.LandAnalysisData = LandAnalysis;
  },
}

const actions = {
  set_landForm({ commit }, data){
    commit('SET_LANDFORM', data)
  },
  set_landTool({ commit }, data){
    commit('SET_LANDTOOL', data)
  },
  set_plateValue({ commit }, data){
    commit('SET_PLATEVALUE', data)
  },
  set_landValue({ commit }, data){
    commit('SET_LANDVALUE', data)
  },
  set_RegulatoryPlan({ commit }, data){
    commit('SET_REGULATORYPLAN', data)
  },
  set_PoiResource({ commit }, data){
    commit('SET_POIRESOURCE', data)
  },
  set_LandAnalysisDATA({ commit }, data){
    commit('SET_LANDANALYSISDATA', data)
  },
}
export default {
  state,
  mutations,
  actions
}